import { createSelector } from 'reselect';

export const selectActiveShow = createSelector(
  [(state, activeShowId) => state.tv.shows, (state, activeShowId) => activeShowId],
  (shows, id) => {
    if (shows.get('loaded') && id) {
      const activeShow = shows.get('data').find(show => show.get('id') === parseInt(id, 10));

      return activeShow ? activeShow : null;
    }
    return null;
  }
);

export const selectActiveEpisode = createSelector(
  [(state, activeEpisodeId) => state.tv.episodes, (state, activeEpisodeId) => activeEpisodeId],
  (episodes, id) => {
    if (episodes.get('loaded') && id) {
      const activeEpisode = episodes.get('data').find(ep => ep.get('id') === parseInt(id, 10));

      return activeEpisode ? activeEpisode : null;
    }
    return null;
  }
);



// WEBPACK FOOTER //
// ./src/tv/selectors.js